import axios from 'axios';
import constants from '../../config/constants';
import { formResMessage } from '../../utils/commonFunc';

export const FETCH_REPORT = 'FETCH_REPORT';
export const CLOSE_REPORT = 'CLOSE_REPORT';

export const getReport = reportData => ({
  type: FETCH_REPORT,
  fileData: reportData.fileData,
  headingName: reportData.headingName,
});

export const closeReportModal = () => ({
  type: CLOSE_REPORT,
});
//= ========== User routing begin ===========//
// Students
const getReportsApi = data => {
  const {
    examTypeDetailId = null,
    schoolId = null,
    batchId = null,
    courseId = null,
    studentId = null,
    employeeId = null,
    // progReportId = null,
    apiName = null,
    studPaymentId = null,
  } = data;
  const apis = {
    // Students reports by course and batch list
    generateBatchStudentsPDFReport: `/api/report/students-namelist-by-batch-pdf/${schoolId}/${batchId}`, // done
    generateCourseStudentsPDFReport: `/api/report/students-namelist-by-course-pdf/${schoolId}/${courseId}/${batchId}`, // done
    generateCourseProgressPDFReport: `/api/report/student-progress-report-by-course/${courseId}/${batchId}`,
    generateStudentsBatchAttendancePDFReport: `/api/report/students-attendance-by-batch-pdf/${batchId}`,
    generateStudentsCourseAttendancePDFReport: `/api/report/students-attendance-by-course-pdf/${courseId}/${batchId}`,

    // Students
    generateHomeworkPDFReport: `/api/report/student-homework/${studentId}`, // done
    generateSimplePDFReport: `/api/report/student-pdf/${studentId}`, // done
    generateStudentProgressPDFReport: `/api/report/student-progress-report/${studentId}/${courseId}/${batchId}`, // done

    // School - Time table, Holiday
    generateCourseTimeTablePDFReport: `/api/report/course-time-table-pdf/${schoolId}/${batchId}/${courseId}`, // done
    generateHolidaCalendarPDFReport: `/api/report/school-holiday-calendar-pdf/${schoolId}`, // done

    // Fees
    generateSchoolCourseFeesStructureReport: `/api/report/all-course-fee-structure-pdf/${schoolId}/${batchId}`,
    // Course fees
    generateCourseFeesStructureReport: `/api/report/course-fee-structure-pdf/${schoolId}/${batchId}/${courseId}`,
    // Student fees
    generateStudentFeesStructureReport: `/api/report/student-fee-structure-pay-history-pdf/${schoolId}/${batchId}/${courseId}/${studentId}`,
    // Student Payment receipt
    generateStudentPaymentReceipt: `/api/report/student-payment-receipt-pdf/${studPaymentId}`,

    // Employees
    generateEmployeePDFReport: `/api/report/employee-pdf/${employeeId}`, // done

    // Course progress report // Not an pdf API
    // getCourseProgressReport: `/api/report/course-progress-report/${examTypeDetailId}`,

    // Student exam progress
    getStudentProgressReport: `/api/report/student-progress-report/${examTypeDetailId}/${studentId}`, // GET

    // Mark
    uploadStudentSubjectMarks: `/api/report/subject-mark`, // No Params
    // uploadStudentSubjectMarks: `/api/report/subject-mark/${progReportId}` // UPDATE
  };
  return apis[apiName];
};

export const fetchReportService = data => async dispatch => {
  const url = getReportsApi(data);

  try {
    const res = await axios({
      method: data.method || 'POST',
      url: constants.API_BASE_URL + url,
      data: null,
      headers: constants.setHeader(data.token).headers,
      responseType: 'arraybuffer',
    });

    dispatch(
      getReport({
        fileData: res.data,
        headingName: data.reportName,
      })
    );
  } catch (err) {
    console.error('Axios error:', err);

    const responseData = err?.response?.data;

    if (!responseData) {
      alert(err?.message || 'Something went wrong');
      return;
    }

    try {
      let errorData;

      if (responseData instanceof ArrayBuffer) {
        const errorText = new TextDecoder('utf-8').decode(responseData);
        errorData = JSON.parse(errorText);
      } else {
        errorData = responseData;
      }

      console.error('Actual API error:', errorData);

      const errRes = formResMessage({
        response: {
          data: errorData,
        },
      });

      if (errRes) {
        alert(errRes);
      }
    } catch (parseError) {
      console.error('Could not parse API error:', parseError);
      alert('Unable to generate report. Please try again.');
    }
  }
};

export const uploadDataService = data => () => {
  const {
    uploadType = '',
    formData = null,
    token,
    schoolId,
    batchId = null,
    courseId = null,
    // studentId = null,
    subjectId = null,
    examTypeDetailId = null,
  } = data;
  let uploadURL = '';
  if (uploadType === 'students') {
    uploadURL = `/api/admin/upload-students/${schoolId}/${batchId}/${courseId}`;
  }
  if (uploadType === 'employees') {
    uploadURL = `/api/admin/upload-employees/${schoolId}`;
  }
  if (uploadType === 'timetable') {
    uploadURL = `/api/admin/upload-time-table/${schoolId}/${batchId}/${courseId}`;
  }
  if (uploadType === 'studentsMark') {
    uploadURL = `/api/admin/upload-students-mark/${schoolId}/${batchId}/${subjectId}/${examTypeDetailId}`;
  }
  if (uploadType === 'schoolLogo') {
    uploadURL = `/api/admin/upload-school-logo-image/${schoolId}`;
  }
  if (uploadURL) {
    return axios({
      method: 'post',
      url: `${constants.API_BASE_URL}${uploadURL}`,
      data: formData,
      headers: {
        ...constants.setHeader(token).headers,
        'Content-Type': 'multipart/form-data',
      },
    });
  } else {
    alert('Upload URL is missing');
  }
};

//= ========== User routing end ===========//
